



import Vue from "vue";
import sidebar from "../src/components/sidebar.vue";
import topbar from "../src/components/topbar.vue";
import axios, { AxiosRequestConfig, AxiosInstance } from "axios";
import router from "./router";


// const axios = require("axios");

export default {
  components: { sidebar, topbar },
  name: "app",
  created() {
    axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        if(!error.response) {
          //network error
          console.log("Nätverksfel - kontrollera din internetanslutning");
          return Promise.reject(error);
        }
        if (401 === error.response.status || 403 === error.response.status) {
          //alert("Du verkar ha blivit utloggad. Vänligen logga in igen.");
          //window.location.href = "/pages/login#/pages/login";
          router.push("/pages/login");
        } else {
          return Promise.reject(error);
        }
      }
    );
  },
};
